<template>
  <div class="authResultBody">
    <div class="authResultMain">
      <div v-if="verifyMsg" class="authenticationResult">
        <img src="@/assets/image/fail.png">
        <h2>认证不通过</h2>
        <dl>
          <dt>不通过原因：</dt>
          <dd>{{ verifyMsg }}</dd>
        </dl>
        <div>
          <el-button v-if="face" type="primary" size="small" @click="blockFace">重新刷脸</el-button>
          <el-button type="primary" size="small" @click="blockAuth">重新认证</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {}
  },
  props: ['verifyMsg','face'],
  methods: {
    blockAuth () {
      this.$emit('blockAuth')
    },
    blockFace () {
      if(this.faceResult) {
        this.$alert('未查到人脸结果，请扫描二维码并完成人脸识别！', '提示', {
        confirmButtonText: '好的',
        type: 'warning'
      })
      }
      this.$emit('blockFace')
    }
  }
}
</script>

<style lang="scss" scoped>
.authResultBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.authResultMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.authenticationResult {
  width: max-content;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 120px;
    margin-top: 52px;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
    margin-top: 18px;
  }
  h5 {
    margin: 8px 0 32px;
    font-size: 14px;
    color: #929292;
    line-height: 22px;
    font-weight: normal;
  }
  dl {
    width: 450px;
    background: #f1f5ff;
    border-radius: 4px;
    padding: 16px;
    margin: 32px 0 70px;
  }
  dt {
    padding-left: 24px;
    background: url('~@/assets/image/warning.png') no-repeat;
    background-size: 16px;
    font-size: 14px;
    color: #333333;
    line-height: 19px;
    font-weight: bold;
  }
  dd {
    margin-top: 12px;
    font-size: 14px;
    color: #595959;
    line-height: 16px;
  }
}
</style>